import { Address, AddressBackend } from "medere-ui-framework";


export interface ManagerDTO {
    medereentity:number,
    businessname:string,
    document:string,
    commercialname:string,    
    entitystate:number,
    entitystatedesc:string,
}

export const initialStateManagerDTO: ManagerDTO={
  medereentity:-1,
  businessname:"",
  document:"",
  commercialname:"",
  entitystatedesc:"",
  entitystate:-1,
};

export interface ManagerGeneralDataDTO {
    code:string,
    addresses: Address[];
    commercialname:string;
    medereentity: number | null;
    entitystate:number;
    entitystatedesc:string
  }

  export const initialStateManager: ManagerGeneralDataDTO={
    code:"",
    medereentity:-1,
    commercialname:"",
    entitystatedesc:"",
    entitystate:-1,
    addresses:[]
};

export interface SaveManagerDTOBackend {
    addresses: AddressBackend[];
    commercialname:string;
    medereentity: number | null;
    entitystate:number;
    code:string
  }

  export interface ManagerFiscalDataDTO {
    medereentityfiscaldata:number,
    medereentity: number,
    fiscaladdress:number,
    fiscaladdressdesc:string;
    businessname:string,
    document:string,
    vatcategory:number;
    vatcategorydesc:string;
    afipstatus:number;
    afipstatusdesc:string;
    iibb: string;
    iibbExclusionPercentage: number;
    iibbFromDate: Date | string| null;
    iibbToDate: Date |string|  null;
    healthentitiesinvoicedseperated:boolean;
    mandatary:boolean;
    businessdays:boolean;
    invoiceduedays:number;
    electroniccreditinvoice:boolean;
    compmedicalservicestaxtype:number;
    compmedicalservicestaxtypedesc:string;
    limitpresentationday:number;
    requiresseparatedinvoices:boolean;
  }

  export const initialStateManagerFiscalData: ManagerFiscalDataDTO={
    medereentityfiscaldata:-1,
    medereentity: -1,
    fiscaladdress:-1,
    fiscaladdressdesc:"",
    businessname:"",
    document:"",
    vatcategory:-1,
    vatcategorydesc:"",
    afipstatus:-1,
    afipstatusdesc:"",
    iibb: "",
    iibbExclusionPercentage: 0,
    iibbFromDate: null,
    iibbToDate: null,
    healthentitiesinvoicedseperated:false,
    mandatary:false,
    businessdays:false,
    invoiceduedays:0,
    electroniccreditinvoice:false,
    compmedicalservicestaxtype:-1,
    compmedicalservicestaxtypedesc:"",
    limitpresentationday:0,
    requiresseparatedinvoices:false
  };
